<template>
    <div class="text-center xl:text-left mb-14 xl:mb-6">
        <!-- * this condition is for SEO purposes, we can improve later -->
        <h1
            v-if="$route.fullPath.includes('pricing')"
            class="lg:text-display-lg text-title-xl text-gray-100 font-bold mb-2"
        >
            {{ $t("pages_pricing_title") }}
            <!-- Simple & Affordable -->
        </h1>
        <h2 v-else class="lg:text-display-lg text-title-xl text-gray-100 font-bold mb-2">
            {{ $t("pages_pricing_title") }}
            <!-- Simple & Affordable -->
        </h2>
        <!-- * this condition is for SEO purposes, we can improve later -->

        <div>
            <div class="text-gray-400 relative text-[12px] md:text-body-lg flex justify-center">
                {{ $t("pages_pricing_desc") }}
            </div>
        </div>
    </div>
</template>

<script setup lang="ts"></script>
